<template>
  <span class="logo-horizontal">
    <img src="@/assets/images/logo/logo_crew_horizontal_white_bg.svg" width="166" height="54">
  </span>
</template>
<script>
export default {
  name: "LogoHorizontal",
  props: {},
};
</script>
